module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/spy-c24f2aed6c43ecac87cef2fb0253b025.svg";